export var IQrWechatLoginStatus = /*#__PURE__*/function (IQrWechatLoginStatus) {
  IQrWechatLoginStatus["CODE_IS_READY"] = "CODE_IS_READY";
  IQrWechatLoginStatus["USER_HAS_SCANNED"] = "USER_HAS_SCANNED";
  IQrWechatLoginStatus["CODE_WAS_EXPIRED"] = "CODE_WAS_EXPIRED";
  IQrWechatLoginStatus["LOGIN_SUCCESS"] = "LOGIN_SUCCESS";
  IQrWechatLoginStatus["ERROR"] = "ERROR";
  return IQrWechatLoginStatus;
}({});
export var IWechatLoginCase = /*#__PURE__*/function (IWechatLoginCase) {
  IWechatLoginCase[IWechatLoginCase["WECHAT_LOGIN_CASE_DEFAULT"] = 0] = "WECHAT_LOGIN_CASE_DEFAULT";
  IWechatLoginCase[IWechatLoginCase["WECHAT_LOGIN_CASE_H5"] = 1] = "WECHAT_LOGIN_CASE_H5";
  return IWechatLoginCase;
}({}); // 获取 H5页面 URL
//# sourceMappingURL=wechat-login.js.map